export default "__VITE_ASSET__CTOhj5M$__"